export default {
  translation: {
    permission: {
      member: '成员',
      group: '群组',
      department: '部门',
      teamManagement: '团队管理',
      membersInTotal: '成员总数',
      createGroup: '创建群组',
      leaveTheTeam: '离开团队',
      owner: '所有者',
      moveDepartment: '移动部门',
      manageMember: '管理成员',
      createSubDepartment: '创建子部门',
      description: '描述',
      descriptionPlaceholder: '请输入描述',
      administrator: '管理员',
      setAsAdministrator: '设置为管理员',
      transferOwner: '转移所有者',
      permissionManagement: '权限管理',
      manage: '管理',
      collaborator: '协作者',
      team: '团队',
      addCollaborator: '添加协作者',
      readPermission: '读取权限',
      writePermission: '写入权限',
      managePermission: '管理权限',
      ownerPermission: '所有者',
      manageCollaborator: '管理协作者',
      permission: '权限',
      transferTo: '转移给',
      keepAdministratorPrivileges: '保留管理员权限',
      avatar: '头像',
      deleteConfirmMessage: '{{id}} 正被 {{type}} 使用，如下所示',
      pleaseShareTheModelFirst: '请先分享以下知识库或模型',
    },
  },
};
